export const pieLinksColors = {
    'Conventional': '#e57373', 'Artistic': '#01b7c4',
    'Realistic': '#ff7143', 'Investigative': '#045978',
    'Social': '#b0006c', 'Enterprising': '#68c083'
};

export const wilCardlinkColors = {
    'independence': '#669601',
    'workConditions': '#ab47bc',
    'relationships': '#96015d',
    'support': '#0c8cbd',
    'recognition': '#0a8f72',
    'achievement': '#510456',
};


export const asmntImages = {
    'CCIAdult': 'cciAdult-landing.png',

    'CCIJr': 'cci-image.png',

    'CCIQuick': 'baby_CCI.png',

    'IDEAS': 'ideas-image.png',

    'MiniIP': 'interest-profiler_mini-icon.png',

    'OccSort': 'Occupation-Sort-icon.png',

    'RealityCheck': 'rc-icon.png',

    'ShortIP': 'Interest-Profiler-icon.png',

    'WIL': 'wil-image.png',

};

export const CCIAsmntConst = ['CCIQuick', 'CCIQuickAdult', 'CCIJr', 'CCIAdult'];
